/* =====================================================
   Numdle Main Application Component – Version 2.1 (Modified: July 31, 2025)
   Date Modified: 31 July 2025 | Time: Current
   🔄 Changes from Version 1.9:
     - Converted to React functional component
     - Modern hooks-based state management
     - Component composition and separation of concerns
     - Enhanced performance optimizations
===================================================== */

import { GameProvider } from './hooks/useGameState'
import Header from './components/Header'
import EquationGrid from './components/EquationGrid'
import GameControls from './components/GameControls'
import FeedbackSection from './components/FeedbackSection'
import GameHeaderWithSettings from './components/GameHeaderWithSettings'
import './App.css'

/**
 * Main application component that orchestrates the Numdle game
 * Provides game state context and renders all game sections
 */
function App() {
  return (
    <GameProvider>
      <div className="app">
        {/* ========================================
             HEADER SECTION
             Displays game title and target number
             ======================================== */}
        <Header />
         {/* ========================================
             GAME header With settings PANEL
             app popup settings button
             ======================================== */}
         <GameHeaderWithSettings />
         
        <main className="main-content">
          {/* ========================================
               EQUATION BUILDING GRID
               6 rows × 11 slots each (6 numbers + 5 operators)
               Players construct their mathematical equations here
               ======================================== */}
          <section className="equation-section">
            <h4>Equation Builder</h4>
            <EquationGrid />
          </section>
        </main>

        {/* ========================================
             GAME CONTROLS PANEL
             Number/operator selection, control buttons, and feedback
             ======================================== */}
        <GameControls />

        {/* ========================================
             FEEDBACK AND TRACKING SECTION
             Shows equation results, validation messages, and calculation steps
             ======================================== */}
        <FeedbackSection />
      </div>
    </GameProvider>
  )
}


export default App
